/**
 * Blur-until-loaded + fallback on error. Does not show a loading placeholder;
 * shows the real image blurred until load, then sharp. On error, shows fallback.
 * Adds class img-blur-until-loaded (and .loaded when done).
 * For units/heroes: reserves space and shows same image blurred in parent background
 * so layout doesn't jump and something is visible immediately.
 */
import { resolveEntityImageUrl } from '../utils/entityImageUrl';

function fallbackForUrl(url) {
  if (!url) return '/images/error.png';
  if (/heroes/.test(url)) return '/images/heroes/error.webp';
  if (/unit/.test(url)) return '/images/units/error.webp';
  if (/spells/.test(url)) return '/images/spells/error.webp';
  if (/equipment/.test(url)) return '/images/equipment/error.webp';
  if (/factions/.test(url)) return '/images/factions/error.webp';
  if (/domains/.test(url)) return '/images/domains/error.webp';
  return '/images/error.png';
}

function isLqipEligibleUrl(url) {
  return /\/heroes\//.test(url) || /\/units\//.test(url) ||
    /\/factions\//.test(url) || /\/domains\//.test(url);
}

export default {
  beforeMount(el, binding) {
    try {
      const { value } = binding;
      const rawUrl = el.src || (typeof value === 'string' ? value : '');
      const mainUrl = resolveEntityImageUrl(rawUrl);
      let fallBackImage = fallbackForUrl(mainUrl);

      if (value instanceof Object && value.fallBackImage) {
        fallBackImage = value.fallBackImage;
      } else if (typeof value === 'string') {
        fallBackImage = value;
      }

      if (!mainUrl) {
        return;
      }

      el.src = mainUrl;

      const parent = el.parentElement;
      const isLqipContainer = parent && (
        parent.classList.contains('unit-image') ||
        parent.classList.contains('hero') ||
        parent.classList.contains('hero-image') ||
        parent.classList.contains('faction-image') ||
        parent.classList.contains('domain-image')
      );
      const useLqip = isLqipContainer && isLqipEligibleUrl(mainUrl);

      const markLoaded = () => {
        el.classList.add('loaded');
        if (useLqip && parent) {
          parent.classList.add('img-lqip-loaded');
        }
      };

      if (el.complete) {
        markLoaded();
        return;
      }

      el.classList.add('img-blur-until-loaded');
      if (useLqip) {
        parent.classList.add('img-lqip-parent');
        parent.style.setProperty('--lqip-bg', 'url(' + mainUrl + ')');
      }

      el.addEventListener('load', markLoaded);
      el.addEventListener('error', () => {
        el.src = fallBackImage;
        markLoaded();
      });
    } catch (e) {
      console.log(e);
    }
  }
};
